import b from 'b_';
import cx from 'classnames';
import React from 'react';
import { accessibleClick, accessibleMouseHover } from '@edu-frontend/modules/src/shared/lib/a11y';

import { RESULT_TABLE_CELL_TYPE } from '../typings';

import './results__table-cell.scss';

interface OwnProps {
    innerRef?: React.Ref<HTMLDivElement>;
    type: RESULT_TABLE_CELL_TYPE;
    mix?: string;
    options?: {
        beforeScroll?: boolean;
    };
}

interface Props extends OwnProps, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

class TableCell extends React.Component<Props> {
    static TYPE = RESULT_TABLE_CELL_TYPE;

    render() {
        const { children, type, options = {}, onClick, onMouseEnter, mix, innerRef, ...otherProps } = this.props;

        return (
            <div
                className={cx(mix, b('results', 'table-cell', { type, 'before-scroll': options?.beforeScroll }))}
                {...accessibleClick(onClick)}
                {...accessibleMouseHover({ onMouseEnter, describedby: false })}
                ref={innerRef}
                {...otherProps}
            >
                {children}
            </div>
        );
    }
}

export default TableCell;
